import React from 'react';
import * as Icon from 'react-feather';

const FeatherIconCom = ({ iconName, ...res }) => {
  const iconCapitalize = iconName
    .split('-')
    .map((Item) => Item.slice(0, 1).toUpperCase() + Item.slice(1))
    .join('');
  const IconComp = Icon[iconCapitalize];
  return <IconComp {...res} />;
};

export default FeatherIconCom;
